import React from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LazyMotion } from "framer-motion";
import { createPortal } from "react-dom";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";

import { App } from "src/App";
import { CONTAINER_CLASS_NAMES } from "src/design-system/Toast/constants";
import { queryClient } from "src/queryClient";
import "src/styles/index.css";

const loadFramerMotionFeatures = () =>
  import("./framer-motion-features").then((res) => res.framerMotionFeatures);

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {createPortal(
        <Toaster containerClassName={CONTAINER_CLASS_NAMES} />,
        document.body,
      )}
      <LazyMotion features={loadFramerMotionFeatures} strict>
        <App />
      </LazyMotion>
      <ReactQueryDevtools initialIsOpen={false} position="bottom" />
    </QueryClientProvider>
  </React.StrictMode>,
);
